export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const prepareAddressData = (address) => {
  let addressPayload = null;
  if (address) {
    addressPayload = {};
    if (address.address_components) {
      address.address_components.forEach((item) => {
        // City
        if (item.types.includes("administrative_area_level_2")) {
          addressPayload.city = item.long_name;
        }

        // State
        if (item.types.includes("administrative_area_level_1")) {
          addressPayload.state = item.long_name;
        }

        // Country
        if (item.types.includes("country")) {
          addressPayload.country = item.long_name;
        }

        // postal code
        if (item.types.includes("postal_code")) {
          addressPayload.pin = item.long_name;
        }
      });
    }

    if (address.latLng) {
      addressPayload.latitude = address.latLng.lat;
      addressPayload.longitude = address.latLng.lng;
    }

    if (address.formatted_address) {
      addressPayload.addressLine2 = address.formatted_address;
    }
    addressPayload.isDefault = true;
  }

  return addressPayload;
};

export const languageLable = (data, key) => {
  var splitVal = "";
  if (String(key).includes(" / ORD")) {
    var splitArr = String(key).split(" / ");
    key = splitArr[0];
    splitVal = splitArr[1];
  }
  if (data[String(key) && String(key).toLowerCase()]) {
    if (splitVal !== "") {
      return data[key && key.toLowerCase()] + " / " + splitVal;
    }
    return data[key && key.toLowerCase()];
  }
  return key;
};

export const updateProductDetails = (product) => {
  let selectedLang = localStorage.getItem("selectedLanguage");
  var currentLanguage = "en-US"
  if (selectedLang != null) {
    currentLanguage = JSON.parse(selectedLang).Locale;
  }
  if (product.ProductDetails.length > 0) {
    let productDetail = product.ProductDetails.find(item => item.Language === currentLanguage);
    if (productDetail != null && productDetail != undefined) {
      product.ProductName = productDetail["Name"];
      product.ProductSummary = productDetail["Summary"];
      product.ProductDescription = productDetail["Description"];
    } else {
        product.ProductName = product.ProductDetails[0]["Name"];
        product.ProductSummary = product.ProductDetails[0]["Summary"];
        product.ProductDescription = product.ProductDetails[0]["Description"];
    }
  } else if (product.CategoryDetails.length > 0) {
    let productDetail = product.CategoryDetails.find(item => item.Language === currentLanguage);
    if (productDetail != null && productDetail != undefined) {
      product.ProductName = productDetail["Name"];
      product.ProductDescription = productDetail["Description"];
    } else {
        product.ProductName = product.CategoryDetails[0]["Name"];
        product.ProductDescription = product.CategoryDetails[0]["Description"];
    }
  } else if (product.ProductGroupDetails.length > 0) {
    let productDetail = product.ProductGroupDetails.find(item => item.Language === currentLanguage);
    if (productDetail != null && productDetail != undefined) {
      product.ProductName = productDetail["Name"];
      product.ProductSummary = productDetail["Summary"];
      product.ProductDescription = productDetail["Description"];
    } else {
        product.ProductName = product.ProductGroupDetails[0]["Name"];
        product.ProductSummary = product.ProductGroupDetails[0]["Summary"];
        product.ProductDescription = product.ProductGroupDetails[0]["Description"];
    }
  } 

  return {
    ...product
  };
};

export const validatePassword = (p) => {
  let errors = [];
  if (
    p.search(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,20}$/
    )
  ) {
    errors.push(
      "Your password length should be 6 to 20 characters & must contain 1-Uppercase, Lowercase, Numeric and Special Character"
    );
  }
  return errors;
};

/**
 * Library Order
 * @param {*} val
 * @returns
 */

export const getConsignmentType = (val) => {
  return val ? "IssueAndFillUp" : "Issue";
};

export const findParameterFromUrl = (location, parameterName) => {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};
